<template>
  <SplitViewTemplate
    :screenConfig="data"
    :backButtonRoute="'/settings/customers'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :setLoading="setLoading"
    :validationSummary="validationSummary"
  />
</template>

<script>
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { SplitViewService } from "../../../_services/api/templates/split-view.services";
import { CustomerService } from "../../../_services/api/customers/customer.service";
// import { CustomerDeliveryAddressService } from '../../../_services/api/customers/customer-delivery-address.service';
// import { SalesRepresentativeService } from "../../../_services/api/sales/sales-rep.service";
// import { UserService } from "../../../_services/api/settings/user/user.service";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      validationSummary: [],
      setLoading: false,
      formModel: {
        IsDefault: "Y",
        IsDefaultData: false,
        SetDefault: true,
        Inactive: true,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Sales Representative",
        pageRoute: "/customer-sales-representative",
        saveEndPoint: "SalesRepresentative",
        recordEndPoint: "SalesRepresentative",
        isDefaultEndPoint: "Save_DefaultSalesRepresentative",
        exportFileName: "Customer SalesRepresentative List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesRepresentative",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "customer-sales-representative",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/customer-sales-representative/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              // /////////
              screenField: "SalesRepresentative",
              dataField: "Code",
              label: "Code",
              allowHiding: false,
              sortOrder: "asc",
              sortIndex: 0,
              required: true,
              width: "auto",
              editorOptions: {
                maxLength: "4",
              },
            },
            {
              screenField: "FirstName",
              label: "First Name",
              allowHiding: false,
              required: true,
              editorOptions: {
                maxLength: "50",
              },
              width: "auto",
            },
            {
              screenField: "Surname",
              required: true,
              editorOptions: {
                maxLength: "50",
              },
            },
            {
              screenField: "Email",
              allowHiding: false,
              editorOptions: {
                maxLength: "200",
              },
              // required: true,
              validationRules: [
                {
                  type: "required",
                  message: "Email is required",
                },
                {
                  type: "email",
                  message: "Email is invalid",
                },
              ],
            },
            {
              dataField: "Mobile",
              label: "Mobile",
              allowHiding: false,
              editorOptions: {
                maxLength: "20",
              },
            },
            {
              dataField: "UserCode",
              label: "Username",
              allowHiding: false,
            },
            {
              dataField: "ChangedBy",
              label: "Changed By",
            },
            {
              screenField: "IsDefault",
              makeDisabled: (data) => {
                return (
                  data.column.dataField == "IsDefault" &&
                  data.data.Inactive == "Y"
                );
              },
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: "0",
              // fixed: false
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "IsDefault",
              listner: async (event, cellInfo, grid, updateIsDefault) => {
                var items = grid.getDataSource().items();
                var getDefault,
                  clickedDefault = undefined;
                if (items)
                  items.forEach((element) => {
                    if (element.Code == cellInfo.data.Code)
                      clickedDefault =
                        element.FirstName + " " + element.Surname;
                    if (element.IsDefault == "Y")
                      getDefault = element.FirstName + " " + element.Surname;
                  });

                if (!getDefault)
                  await SplitViewService.getIsDefault(
                    "SalesRepresentative"
                  ).then((res) => {
                    if (res.data.value.length > 0)
                      getDefault =
                        res.data.value[0].FirstName +
                        " " +
                        res.data.value[0].Surname;
                  });

                let confirmLeaving = await this.$confirm(
                  getDefault
                    ? `Do you want to change the default setting from ${getDefault} to ${clickedDefault} ?`
                    : `Do you want to change the default setting to ${clickedDefault} ?`,
                  "Default Setting Change"
                );

                if (!confirmLeaving) {
                  event.component.beginUpdate();
                  event.component.option("value", false);
                  event.component.endUpdate();
                  return;
                }
                if (updateIsDefault) {
                  this.$store.dispatch("ui/setUpdateIsDefault", {
                    update: true,
                    code: cellInfo.data.Code,
                    event: event,
                  });
                }
              },
            },
          ],
        },
      },
    };
  },
  computed: {
    setDefaultEdit() {
      return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    },
    setActiveReadOnly() {
      return this.formModel["SetDefault"] ? true : false;
    },
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: true,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
                onValueChanged: (e) => {
                  this.onActiveValueChanged(e);
                },
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                required: true,
                allowUpdate: true,
                screenField: "Code",
                isPrimaryKeyField: true,
              },
              {
                // dataField: "FirstName",
                label: {
                  text: "First Name",
                },
                required: true,
                allowUpdate: true,
                screenField: "FirstName",
                isPrimaryKeyField: true,
              },
              { screenField: "Surname", required: true, allowUpdate: true },
              {
                screenField: "Email",
                required: true,
                allowUpdate: true,
              },
              {
                dataField: "Mobile",
                label: {
                  text: "Mobile",
                },
                required: true,
                allowUpdate: true,
              },
              {
                screenField: "GcorpUser",
                dataField: "UserCode",
                // editorType: "dxSelectBox",
                allowUpdate: true,
              },

              {
                screenField: "IsDefault",
                dataField: "SetDefault",
                editorOptions: {
                  readOnly: this.setDefaultEdit,
                },
              },
            ],
          },
        ],
      };

      return form;
    },
  },
  methods: {
    async onActiveValueChanged(e) {
      if (
        this.baseView.mode == "edit" &&
        e.value == false &&
        e.previousValue == true
      ) {
        this.setLoading = true;
        await CustomerService.getCustomerData(
          `SalesRepresentativeCode eq '${this.formModel["Code"]}'`
        )
          .then((res) => {
            this.setLoading = false;

            if (res.data.value.length > 0) {
              this.formModel.Inactive = true;

              e.component.beginUpdate();
              e.component.option("value", true);
              e.component.endUpdate();

              this.validationSummary = [];
              this.validationSummary.push({
                message: `${this.formModel["Code"]} is associated with Customer Sales Representative Code records. This may not be marked inactive until it is no longer associated with Customer Sales Representative  records.`,
              });
              this.validationSummary.push({
                message: `Tip: To identify the associated Customer Sales Representative Code use the filters on the Customer Sales Representative Codelist.`,
              });
            }
          })
          .catch((err) => {
            if (err) this.setLoading = false;
          });
      }
    },
  },
};
</script>
